import React from "react";
import { Button, Dropdown, Icon, Menu } from "antd";
import Config from "../../config";
import { stopJump } from "../../utils/common";

interface LiveButtonProps {
    channelId: string;
    className: string;
    text?: string;
    havePreview?: boolean;
}

export default function LiveButton({
    className,
    channelId,
    text = "去上课",
    havePreview = false
}: LiveButtonProps) {
    function onLiveClick(type: number) {
        let url = "";
        switch (type) {
            case 1:
                url = `${Config.LiveUrl}?channelId=${channelId}`;
                break;
            case 2:
                url = `${Config.LiveUrlClient}?channelId=${channelId}`;
                break;
            case 3:
                url = `${Config.LiveUrl}?userId=0&channelId=${channelId}`;
                break;
            default:
                break;
        }
        return stopJump(url, null);
    }

    return (
        <Dropdown
            overlay={
                <Menu>
                    <Menu.Item key="1" onClick={() => onLiveClick(1)}>
                        <Icon type="chrome" /> 网页直播
                    </Menu.Item>
                    <Menu.Item key="2" onClick={() => onLiveClick(2)}>
                        <Icon type="youtube" /> 客户端直播
                    </Menu.Item>
                    {havePreview && (
                        <Menu.Item key="3" onClick={() => onLiveClick(3)}>
                            <Icon type="zoom-in" /> 预览
                        </Menu.Item>
                    )}
                </Menu>
            }
            className={className}>
            <Button type="primary" onClick={() => onLiveClick(1)}>
                {text} <Icon type="down" />
            </Button>
        </Dropdown>
    );
}
